<script>
    export let name;
    import { onMount } from 'svelte';
    import moment from 'moment';
    let games = [];
    //console.log();
    onMount(async () => {
		//var myHeaders = new Headers();
        //myHeaders.append("Cookie", "ACT_SSO_COOKIE=MTAzNjMyODY3ODU0OTYwMzI5MzoxNjI1MzQwMDc3NTAxOjY0NDczODdiNDExMGQ3MDA5MWNmNjBiZTQyNWRkYjY0; ACT_SSO_COOKIE_EXPIRY=1591153892430; atkn=eyJhbGciOiAiQTEyOEtXIiwgImVuYyI6ICJBMTI4R0NNIiwgImtpZCI6ICJ1bm9fcHJvZF9sYXNfMSJ9.AqBZmXDT5-qIox_T0F-jdLqeI_WunzL1sETbNN1CNTNlTpG_8xbArA.6s97Stk0CGzJNwzK.EhKkjSWfzMj5ll_r76xZKyYg8vl3q9-0r0PiMx4H22oumyhy7k2PfK-CJdU25gpGFZT0w6xmAypvFqlKTnIxplyNGbvegqv8PhU_dE-z2PWe-4W8d3UyfvtX4veaTP31-E2LFO2RYY4_7OAL-tC7QfYInemoYUYdkoB1_5P21gLeWB9scO33-hK_2UISqebDfyGg93WzNBVFnJBGsN3dvOSevJUZ3kbDPcsLjWb27Ujh1aIWodCRa3ofWSeO21-aUiDI-IkOa4D8YlLVt9wMd7nLuDYx2BT5fVIqGLu5MiA10q0nSxZ6YZESC7GvL7-tJ4Jk5gxMPUO9t8aMuuyIsOPIuqzPqp7bthJVFCDX3PQiPQ9olwvyzn8N6G7E2Em1rwHse4u0AznwfVDEw6RJnOkkmgic92r8HXllz7XbUPHDqSbeEGtQPGDd6R6-adITpLgJFkUZwp3_a7rlcyfPCo-u.7ioSZhtIwwvMI0snSUjSbA;; API_CSRF_TOKEN=88a46f36-705a-46b0-803e-5b7425c4f2a3; ak_bmsc=107996015B5095A26B7F1DC052D45096~000000000000000000000000000000~YAAQL3FAF41mfg16AQAAp4G8JQyn/gFIj4IVWXSj7R7tssQBSNIHwfC7vVT9X2ISVBl5eRIyw+nYFP5U015HTkizBl1/JGL16ACxwVXQ2Jn3zYJvkbB0VvVJ9Cq+7ISvB7gYPDRB9pP05c77blWTNqvXwoRdJqqVFnsciVcXXh8wWyPih2HAcrRE2u6AIxhv2DjauYbvlFAmUM189BiGhj7qB5iSN2n/zBMB3FVi/EkfwDA/xaaHkTFnefX/60qrgQQvb1bEysuEV0/+oDDvRYO3g+PDQoHtUpeT7tnl76kGLDXJaH9OUMQrKuADQoYujwdxZ5J9LsxpZzw1yyQKLubnqnvJPEx6w1KrHKIvNh3tRxmHYVdsicCOdDlF; bm_sv=194D226EA661A1FF75FB09B4E679C0D5~QmWLAqbfv2w+DSe77wngiag8p6dYFw7si4bMavPVCRpbsbvl9EChsFmjAncAyf00EYvyPUvz9I3c2KVARBxGS6PQceAy6Ry+QllQoxorcrqmSZEkf9dvcF0B9+BUzvCaiuQeX5IzD1TzooCcIAHaXAqzhQ76+5x0WL7+jmRoxAg=");

        var requestOptions = {
        method: 'GET',
        //headers: myHeaders,
        redirect: 'follow'
        };

        fetch("https://fucksteveapi.azurewebsites.net", requestOptions)
        .then(response => response.json())
        .then(result => {
            console.log(result)
            games = result.data.matches;
        })
        .catch(error => console.log('error', error));
    });
</script>

<main>
	<h1>FUCK {name}</h1>
    <h1>{name} BAD</h1>
    <h2>Warzone Stats</h2>
    {#each games as game, i}
        <div style="padding-bottom: 20px;">
            <p>{moment.unix(game.utcStartSeconds).format("MM/DD/YYYY")}</p>
            <p>Kills: {game.playerStats.kills}</p>
            <p>Deaths: {game.playerStats.deaths}</p>
            <p>Assists: {game.playerStats.assists}</p>
            <p>Damage: {game.playerStats.damageDone}</p>
            <p>Finish Rank: {game.playerStats.rank}</p>
        </div>
    {/each}
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>